const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        welcome: "Bem-vindo",
        chooseLanguage: "Selecione o idioma",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      common: {
        close: "Fechar"
      },
      global: {
        buttons: {
          ok: "Ok",
          cancel: "Cancelar",
          add: "Adicionar",
          save: "Salvar",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexões",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          number: "Telefone",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida",
          phone: "Número do Telefone",
          phoneHelper: "Ex: 5511999999999 (Código do País + DDD + Número)"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "WhatsApp salvo com sucesso.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
        pairCodeMessage: "Código de Pareamento",
        pairCodeHelp: "Digite este código no seu WhatsApp > Aparelhos Conectados > Conectar com número de telefone"
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          downloadModel: "Baixar Modelo",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      tags: {
        title: "Etiquetas",
        table: {
          name: "Nome",
          color: "Cor",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Etiqueta",
        },
        toasts: {
          success: "Etiqueta criada com sucesso!",
          deleted: "Etiqueta excluída com sucesso!",
        },
        form: {
          name: "Nome",
          color: "Cor",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          tags: "Tags",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldConnectionLabel: "Transferir para conexão",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldConnectionPlaceholder: "Selecione uma conexão",
        noOptions: "Nenhum usuário encontrado com esse nome",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        buttons: {
          accept: "Aceitar",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
        toasts: {
          noWhatsapp: "Selecione uma conexão antes de pesquisar o contato.",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          tickets: "Conversas",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
          attendance: "Atendimento",
          automation: "Automação",
          chatbot: "Chatbot",
          appointments: "Agendamento"
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
          },
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Setores",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexões",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          ticketHistoryRetention: {
            name: "Retenção de Histórico (dias)",
            description: "Dias para manter conversas no mesmo ticket",
          },
        },
      },
      chatbot: {
        menu: "Chatbot",
        title: "Construtor de Chatbot",
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        history: "Históricos - Prospecção",
        confirmationModal: {
          title: "Deletar o ticket do contato",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        forward: "Encaminhar",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
        deleteForever: "Excluir Definitivamente",
        edit: "Editar",
        success: "Mensagem editada com sucesso!",
      },
      forwardMessageModal: {
        title: "Encaminhar Mensagem",
        searchPlaceholder: "Buscar contato pelo nome...",
        selectedContacts: "Contatos selecionados",
        preview: "Mensagem a encaminhar",
        noContacts: "Nenhum contato selecionado. Busque e selecione ao menos um contato.",
        mediaMessage: "📎 Arquivo de mídia",
        forwardButton: "Encaminhar",
        sending: "Enviando {{current}} de {{total}} contatos...",
        success: "Mensagem encaminhada com sucesso para {{sent}} contato(s)!",
        partialSuccess: "Encaminhado para {{sent}} contato(s). {{failed}} falha(s).",
        error: "Erro ao encaminhar a mensagem.",
        failedContacts: "Contatos com falha:",
        cancel: "Cancelar",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_WAPP_INVALID_NUMBER:
          "Este número não está cadastrado no whatsapp.",
      },
      schedules: {
        title: "Escalas",
        searchPlaceholder: "Pesquisar...",
        table: {
          name: "Mensagem",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Escala",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir escala",
          deleteMessage: "Tem certeza que deseja excluir esta escala?",
        },
        toasts: {
          deleted: "Escala excluída com sucesso.",
        },
        titles: {
          add: "Adicionar Escala",
          edit: "Editar Escala",
        }
      },
      specialties: {
        title: "Especialidades",
        table: {
          name: "Nome",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Especialidade",
        },
        toasts: {
          deleted: "Especialidade excluída com sucesso!",
          success: "Especialidade salva com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Excluir Especialidade",
          deleteMessage: "Tem certeza que deseja excluir esta especialidade?",
        },
        modal: {
          add: "Adicionar Especialidade",
          edit: "Editar Especialidade",
          form: {
            name: "Nome"
          }
        }
      },
      professionals: {
        title: "Profissionais",
        table: {
          name: "Nome",
          email: "Email",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Profissional",
        },
        toasts: {
          deleted: "Profissional excluído com sucesso!",
          success: "Profissional salvo com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Excluir Profissional",
          deleteMessage: "Tem certeza que deseja excluir este profissional?",
        },
        modal: {
          add: "Adicionar Profissional",
          edit: "Editar Profissional",
          form: {
            name: "Nome",
            email: "Email",
            phone: "Telefone",
            specialties: "Especialidades"
          }
        }
      },
      subSpecialties: {
        title: "Serviços",
        table: {
          name: "Nome",
          duration: "Duração (min)",
          price: "Preço",
          specialty: "Especialidade",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Serviço",
        },
        toasts: {
          deleted: "Serviço excluído com sucesso!",
          success: "Serviço salvo com sucesso!",
        },
        confirmationModal: {
          deleteTitle: "Excluir Serviço",
          deleteMessage: "Tem certeza que deseja excluir este serviço?",
        },
        modal: {
          add: "Adicionar Serviço",
          edit: "Editar Serviço",
          form: {
            name: "Nome",
            duration: "Duração (min)",
            price: "Preço",
            specialty: "Especialidade"
          }
        }
      },
      appointments: {
        title: "Agenda",
        calendar: {
          month: "Mês",
          week: "Semana",
          day: "Dia",
          today: "Hoje",
          back: "Voltar",
          next: "Próximo"
        },
        filters: {
          allProfessionals: "Todos os Profissionais",
          selectDate: "Selecione a Data"
        },
        status: {
          free: "Livre",
          busy: "Ocupado",
          lunch: "Almoço"
        },
        modal: {
          add: "Novo Agendamento",
          form: {
            professional: "Profissional",
            service: "Serviço",
            date: "Data",
            time: "Horário",
            patient: "Paciente"
          }
        }
      },
      campaigns: {
        title: "Campanhas",
        table: {
          name: "Nome",
          status: "Status",
          contacts: "Contatos",
          sent: "Enviadas",
          delivered: "Entregues",
          read: "Lidas",
          failed: "Falhas",
          createdAt: "Criada em",
          actions: "Ações"
        },
        status: {
          draft: "Rascunho",
          scheduled: "Agendada",
          sending: "Enviando",
          paused: "Pausada",
          done: "Concluída",
          error: "Erro"
        },
        buttons: {
          add: "Nova Campanha",
          view: "Visualizar",
          edit: "Editar",
          start: "Iniciar",
          pause: "Pausar",
          continue: "Continuar",
          clone: "Clonar",
          delete: "Excluir",
          downloadModel: "Baixar Modelo",
          config: "Painel API"
        },
        configModal: {
          title: "Painel de Controle API (Uazapi)",
          description: "Aqui você vê todas as campanhas em execução na API deste WhatsApp, inclusive as iniciadas por fora ou fantasmas. Cuidado ao deletar."
        },
        toasts: {
          saved: "Campanha salva com sucesso",
          deleted: "Campanha deletada com sucesso",
          started: "Campanha iniciada com sucesso",
          controlled: "Ação executada com sucesso",
          cloned: "Campanha clonada com sucesso"
        },
        confirmationModal: {
          deleteTitle: "Deletar Campanha",
          deleteMessage: "Tem certeza que deseja deletar esta campanha? Esta ação não pode ser revertida.",
          pauseTitle: "Pausar Campanha",
          pauseMessage: "Tem certeza que deseja pausar esta campanha?"
        },
        modal: {
          title: {
            add: "Nova Campanha",
            edit: "Editar Campanha"
          },
          tabs: {
            definitions: "Definições",
            message: "Mensagem",
            greetings: "Saudações",
            optOut: "Opção Sair"
          },
          form: {
            name: "Nome da Campanha",
            whatsapp: "Conexão WhatsApp",
            uploadCsv: "Upload CSV",
            csvHelper: "Colunas: number, name, variavel01, variavel02, variavel03",
            delayMin: "Intervalo Mínimo (segundos)",
            delayMax: "Intervalo Máximo (segundos)",
            startTime: "Horário Início",
            endTime: "Horário Fim",
            message: "Mensagem",
            variablesHelper: "Clique nas variáveis para inserir:",
            optOutKeyword: "Palavra-chave para sair",
            optOutMessage: "Mensagem de confirmação",
            messageType: "Tipo de Mensagem",
            mediaUrl: "URL da Mídia",
            uploadMedia: "Upload de Mídia",
            mediaHelper: "Faça upload da imagem, vídeo ou PDF"
          },
          messageTypes: {
            text: "Texto Simples",
            image: "Texto + Imagem",
            video: "Texto + Vídeo",
            document: "Texto + PDF",
            button: "Botões",
            list: "Lista/Menu",
            carousel: "Carrossel"
          },
          buttons: {
            cancel: "Cancelar",
            save: "Salvar"
          }
        }
      },
      products: {
        title: "Produtos",
        table: {
          name: "Nome",
          price: "Valor",
          color: "Cor",
          image: "Imagem",
          actions: "Ações"
        },
        buttons: {
          add: "Adicionar Produto",
          importCSV: "Importar CSV"
        },
        toasts: {
          deleted: "Produto excluído com sucesso!",
          success: "Produto salvo com sucesso!",
          imported: "Produtos importados com sucesso!"
        },
        confirmationModal: {
          deleteTitle: "Excluir Produto",
          deleteMessage: "Tem certeza que deseja excluir este produto?"
        },
        modal: {
          add: "Adicionar Produto",
          edit: "Editar Produto",
          form: {
            name: "Nome do Produto",
            price: "Valor",
            color: "Cor",
            image: "Imagem"
          }
        },
        importModal: {
          title: "Importar Produtos via CSV",
          instructions: "O arquivo CSV aceita vírgula (,) ou ponto e vírgula (;) como separador. Formato: nome,valor,cor",
          downloadExample: "Baixar Exemplo"
        }
      },
      kanban: {
        management: {
          title: "Gerenciar Kanban"
        },
        tabs: {
          funnels: "Funis",
          cards: "Cards",
          lossReasons: "Motivos de Perda",
          opportunities: "Oportunidades"
        },
        funnels: {
          title: "Funis",
          buttons: {
            add: "Adicionar Funil"
          },
          table: {
            name: "Nome",
            description: "Descrição",
            actions: "Ações"
          },
          modal: {
            add: "Adicionar Funil",
            edit: "Editar Funil",
            form: {
              name: "Nome",
              description: "Descrição"
            }
          },
          toasts: {
            success: "Funil salvo com sucesso",
            deleted: "Funil deletado com sucesso"
          }
        },
        cards: {
          title: "Cards",
          buttons: {
            add: "Adicionar Card"
          },
          table: {
            name: "Nome",
            type: "Tipo",
            percentage: "Percentual",
            color: "Cor",
            actions: "Ações"
          },
          types: {
            controle: "Controle",
            conversao: "Conversão",
            perda: "Perda"
          },
          modal: {
            add: "Adicionar Card",
            edit: "Editar Card",
            form: {
              name: "Nome",
              type: "Tipo",
              percentage: "Percentual (%)",
              color: "Cor"
            }
          },
          toasts: {
            success: "Card salvo com sucesso",
            deleted: "Card deletado com sucesso"
          }
        },
        lossReasons: {
          title: "Motivos de Perda",
          buttons: {
            add: "Adicionar Motivo"
          },
          table: {
            name: "Nome",
            description: "Descrição",
            actions: "Ações"
          },
          modal: {
            add: "Adicionar Motivo",
            edit: "Editar Motivo",
            form: {
              name: "Nome",
              description: "Descrição"
            }
          },
          toasts: {
            success: "Motivo salvo com sucesso",
            deleted: "Motivo deletado com sucesso"
          }
        },
        opportunities: {
          title: "Oportunidades",
          buttons: {
            add: "Adicionar Oportunidade"
          },
          table: {
            title: "Título",
            card: "Card",
            contact: "Contato",
            value: "Valor",
            actions: "Ações"
          },
          modal: {
            add: "Adicionar Oportunidade",
            edit: "Editar Oportunidade",
            form: {
              title: "Título",
              description: "Descrição",
              card: "Card",
              contact: "Contato",
              value: "Valor Estimado",
              products: "Produtos"
            }
          },
          toasts: {
            success: "Oportunidade salva com sucesso",
            deleted: "Oportunidade deletada com sucesso"
          }
        },
        confirmationModal: {
          deleteTitle: "Confirmar Exclusão",
          deleteMessage: "Tem certeza que deseja deletar este item?"
        },
        board: {
          title: "Kanban",
          selectFunnel: "Selecionar Funil",
          buttons: {
            newOpportunity: "Nova Oportunidade"
          },
          stats: {
            totalOpportunities: "Total de Oportunidades",
            totalValue: "Valor Total",
            conversionRate: "Taxa de Conversão"
          },
          toasts: {
            moved: "Oportunidade movida com sucesso"
          }
        }
      },
      whatsappQRCode: {
        title: "QR Code WhatsApp",
        description: "Gere QR Codes personalizados para WhatsApp",
        form: {
          whatsappNumber: "Número do WhatsApp conectado",
          messageText: "Mensagem pré-preenchida",
          messageHelper: "Esta mensagem será pré-preenchida quando o usuário escanear o QR Code"
        },
        buttons: {
          generate: "Gerar QR Code",
          generating: "Gerando...",
          download: "Baixar Imagem"
        },
        preview: {
          title: "Preview do QR Code"
        },
        info: {
          title: "Como usar:",
          step1: "1. Digite a mensagem que deseja pré-preencher no WhatsApp",
          step2: "2. Clique em 'Gerar QR Code' para criar a imagem",
          step3: "3. Baixe a imagem e use em materiais impressos (flyers, cartões, banners)",
          step4: "4. Quando alguém escanear o QR Code, o WhatsApp abrirá automaticamente com sua mensagem",
          tip: "Dica: Use mensagens curtas e diretas para melhor conversão!"
        },
        toasts: {
          success: "QR Code gerado com sucesso!",
          error: "Erro ao gerar QR Code",
          downloadStarted: "Download iniciado!",
          noMessage: "Por favor, digite uma mensagem",
          noWhatsApp: "Nenhum WhatsApp conectado encontrado"
        }
      },
      emailTemplates: {
        title: {
          add: "Adicionar Template",
          edit: "Editar Template",
          list: "Lista de Templates"
        },
        form: {
          name: "Nome do Template",
        },
        toasts: {
          success: "Template salvo com sucesso!",
          deleted: "Template excluído com sucesso!"
        },
        buttons: {
          add: "Novo Template",
          save: "Salvar",
          cancel: "Cancelar"
        },
        table: {
          name: "Nome",
          actions: "Ações"
        }
      },
    },
  },
};

export { messages };
